
import { Component, Vue } from 'vue-property-decorator';
import EventAttendantRepository from '@/services/Calendar/EventAttendant';
import { WPXFormValue } from "@/components/templates/WPXForm";
import { EditEventAttendant } from '@/services/Calendar/EventAttendant/forms/EditEventAttendant';
import EventsRepository from "@/services/Calendar/Events";
import { EventsInterface } from '@/services/Calendar/Events/Interfaces';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  components: {
    PageHeader,
  },
  inject: [
    'eventsRepository',
    'eventAttendantRepository',
  ],
})
export default class EventSingup extends Vue {
  private readonly eventsRepository!: EventsRepository;
  private readonly eventAttendantRepository!: EventAttendantRepository;

  private form: WPXFormValue<EditEventAttendant> = new WPXFormValue(EditEventAttendant);
  private event: EventsInterface = {} as unknown as EventsInterface;
  private loading: boolean = true;
  private months: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  private async created(): Promise<void> {
    this.form.data.userId = this.$store.getters.id;
    this.event = await this.eventsRepository.getEvent(Number(this.$route.params.eventId));
    this.event.date = new Date(this.event.date);
    this.loading = false;
  }

  private async singUp(): Promise<void> {
    try {
      await this.eventAttendantRepository.createAttendantForEvent({
        eventId: Number(this.$route.params.eventId),
        userId: this.form.data.userId,
        additionalInfo: this.form.data.additionalInfo,
      });

      this.$successDialog.show(`You have successfully registered for this event.`);

      this.formReset();
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }

  private formReset(): void {
    this.form.data.additionalInfo = '';
  }
}
